import React from 'react';
import { connect } from 'react-redux';
import styles from './overview-page.scss';
import PropTypes from 'prop-types';
import BubbleChart from '../../components/bubble-chart';
import * as selectors from '../../reducers';
import ClusterHeadlineAndToolTip from '../../components/cluster-headline-and-tooltip';

class OverviewPage extends React.Component {
  render() {
    const { projects, tabChangeRequested } = this.props;
    return (
      <div className={styles.overviewContainer}>
        <h1
          className={`${styles.overviewHeading} ${tabChangeRequested
            ? styles.overviewHeadingLeaving
            : ''}`}
        >
          Digital Government Projects
        </h1>
        <div className={styles.chartWrapper}>
          <ClusterHeadlineAndToolTip title={''} data={projects} />
          <BubbleChart title={''} data={projects} />
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => ({
  projects: selectors.getAllProjects(state),
  tabChangeRequested: selectors.tabChangeRequested(state),
});

OverviewPage.propTypes = {
  projects: PropTypes.array,
  tabChangeRequested: PropTypes.bool,
};

export default connect(mapStateToProps, null)(OverviewPage);



// WEBPACK FOOTER //
// ./src/pages/overview-page/overview-page.js